import { render, staticRenderFns } from "./publicity.vue?vue&type=template&id=7b4a8b8f&scoped=true"
import script from "./publicity.vue?vue&type=script&lang=js"
export * from "./publicity.vue?vue&type=script&lang=js"
import style0 from "./publicity.vue?vue&type=style&index=0&id=7b4a8b8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4a8b8f",
  null
  
)

export default component.exports